import React from "react";
import { withTranslation } from 'react-i18next';

import HeatmapLayer from 'react-leaflet-heatmap-layer';

class HeatMap extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.points.length !== nextProps.points.length) {
            return true
        }
        return false
    }

    render() {
        return (
            <HeatmapLayer
                points={this.props.points}
                longitudeExtractor={m => m[1]}
                latitudeExtractor={m => m[0]}
                intensityExtractor={m => parseFloat(m[2])} />
        )
    }
}

export default withTranslation()(HeatMap)
